import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup, NgModel } from '@angular/forms';
import { AlertService } from 'src/app/services/alert-service.service';
import { DigiCodService } from 'src/app/services/digicod.service';
import { FormChangeService } from 'src/app/services/form-change.service';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { ReaderService } from 'src/app/services/reader.service';

@Component({
  selector: 'app-form-min-readers',
  templateUrl: './form-min-readers.component.html',
  styleUrls: ['./form-min-readers.component.scss']
})
export class FormMinReadersComponent implements OnInit {

  dateRange = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  sites: {};
  selectedCustomer: string;
  prospects;
  selectedSite: any[];

  selectAll: boolean;
  searchText: string;
  searchTextCust: string;
  newSearched = true;
  numeroMin: number;
  numeroMax: number;
  model: NgModel;
  countAnnonces;
  @Input() withPeriod: boolean;
  period: any;
  selectedPeriod: string;
  periodList: any[];
  constructor(
    private alertService: AlertService,
    private readerService: ReaderService,
    private formService: FormChangeService,
    public router: Router) {
  }


  ngOnInit() {
    this.rechercher();
    this.subscribeReloadSearchRequest();
  }

  subscribeReloadSearchRequest() {
    this.formService.reloadReadersRequest.subscribe(
      () => {

        this.rechercher();
      });
  }
  // efface le formulaire de rechercher appelé depuis navBar
  clearForm() {
    this.rechercher();
  }
  private findTextInProspect(prospects) {
    let filter = this.getTextFilter();
    let resultFiltred = prospects;
    if (filter) {
      let text = filter.split(' ');
      resultFiltred = prospects.filter(function (item) {
        let flt = text.every(function (el) {
          let tmp = (item['label'] && item['label'].toUpperCase().indexOf(el.toUpperCase()) > -1)
            //|| (item['desc'] && item['desc'].toUpperCase().indexOf(el.toUpperCase()) > -1)
            //|| (item['creationBy'] && item['creationBy'].toUpperCase().indexOf(el.toUpperCase()) > -1);
            return tmp;
        });

        return flt;
      });

    }
    resultFiltred = this.filterDigicodDateRange(resultFiltred);
    return resultFiltred;
  }
  filterDigicodDateRange(prospectFiltred: Array<any>): any {
    let tmp = prospectFiltred;
    if(this.dateRange.get('start').value){
      let start = moment(this.dateRange.get('start').value).startOf('day');
        tmp = tmp.filter(element => {
          let dateCreation = element.dateCreation?moment(element.dateCreation): null;
          return dateCreation && dateCreation.startOf('day').isSameOrAfter(start);
        });
      }
      if(this.dateRange.get('end').value){
        let end = moment(this.dateRange.get('end').value).startOf('day');
          tmp = tmp.filter(element => {
            let dateCreation = element.dateCreation?moment(element.dateCreation): null;
            return dateCreation && dateCreation.startOf('day').isSameOrBefore(end);
          });
      }
    return tmp;
  }

  private getTextFilter() {
    return this.searchText;
  }

rechercher() {
    this.getReadersFromBackEnd()
      .subscribe(
        (data) => {
          let tmpRes = data as Array<any>;
           tmpRes = this.findTextInProspect(tmpRes);
          this.formService.raiseReadersListEvent(tmpRes);
        }
        , (error) => {
          console.log(error);
          this.formService.raiseReadersListEvent([]);
        });
  }

  onFormChange() {
    this.rechercher();
  }

  getReadersFromBackEnd() {
    return this.readerService.getReadersFromBack();
  }
}
